/**
 * Step 2b — Targets
 *
 * Firm-wide benchmark targets for Executive Dashboard reference lines.
 * Embeds General Settings → Targets tab only.
 */

import { StepWrapper } from '../StepWrapper';
import { SettingsGeneralPage } from '@/pages/settings-general';

interface StepProps {
  onNext: () => void;
  onBack: () => void;
  onSkip: () => void;
  isLastStep: boolean;
}

export function Step2bTargets({ onNext, onBack, onSkip, isLastStep }: StepProps) {
  return (
    <StepWrapper
      barState="default"
      barMessage="Set firm-wide benchmark targets used as reference lines on the Executive Dashboard."
      showBack={true}
      showSkip={true}
      nextLabel={isLastStep ? 'Finish Setup →' : 'Next Step →'}
      onNext={onNext}
      onBack={onBack}
      onSkip={onSkip}
    >
      <div className="rounded-lg border border-border overflow-hidden bg-background shadow-sm">
        <SettingsGeneralPage defaultTab="targets" />
      </div>
    </StepWrapper>
  );
}
